<template>
  <v-app>
    <core-app-bar />

    <core-drawer :image="bgMenu" :logo="logo" :links="menu"/>

    <core-view />

  </v-app>
</template>

<script>
import menu from "../config/menu.js";
export default {
  data: () => ({
    logo: require('../assets/logo.png'),
    bgMenu: require('../assets/contabilidade.jpg'),
    menu: menu
  }),
  
  components: {
    CoreDrawer: () => import('./core/Drawer'),
    CoreAppBar: () => import('./core/AppBar'),
    CoreView: () => import('./core/View')
  }
}
</script>